import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin: 20px auto 40px;\n  @media (max-width: ', ') {\n    display: inline-block;\n    width: 100%;\n  }\n'], ['\n  margin: 20px auto 40px;\n  @media (max-width: ', ') {\n    display: inline-block;\n    width: 100%;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-bottom: 30px;\n  padding: 0 20px;\n'], ['\n  margin-bottom: 30px;\n  padding: 0 20px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 42px;\n  margin: 0.8em 0;\n  text-align: center;\n  font-style: italic;\n  @media (max-width: ', ') {\n    font-size: 32px;\n  }\n'], ['\n  font-size: 42px;\n  margin: 0.8em 0;\n  text-align: center;\n  font-style: italic;\n  @media (max-width: ', ') {\n    font-size: 32px;\n  }\n']);

import styled from 'styled-components';

export var StyledPanoGridDiv = styled.div(_templateObject, function (props) {
  return props.theme.desktopWidth;
});

export var StyledDiv = styled.div(_templateObject2);

export var StyledH3 = styled.h3(_templateObject3, function (props) {
  return props.theme.tabletWidth;
});